import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@vltansky/ng-select';
import { BllExpandModule } from './expand';
import { BllAccordionModule } from './accordion';
import { BllAccordionWorkflowModule } from './accordion-workflow';
import { BllCheckboxModule } from './checkbox';
import { BllRadioModule } from './radio';
import { BllInputModule } from './input';
import { BllFormFieldModule } from './form-field';
import { BllButtonModule } from './button';
import { BllSelectModule } from './select';
import { BllAutocompleteModule } from './autocomplete';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { BllTooltipModule } from './tooltip';
import { BllModalModule } from './modal';
import { BllLoaderModule } from './loader';
import { BllSkeletonTextModule } from './skeleton-text';
import { BllIconModule } from './icon';
import { BllHintModule } from './hint';
import { popperVariation, tooltipVariation } from './hint/defaults';
import { BllDialogModule } from './dialog';
import { BllTableModule } from './table';
// import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// add new import modules here -- keep this line for generators

const bllModules = [
  BllExpandModule,
  BllAccordionModule,
  BllAccordionWorkflowModule,
  BllCheckboxModule,
  BllRadioModule,
  BllInputModule,
  BllFormFieldModule,
  NgSelectModule,
  BllButtonModule,
  BllSelectModule,
  BllAutocompleteModule,
  BllTooltipModule,
  BllLoaderModule,
  BllModalModule,
  BllSkeletonTextModule,
  NgbTooltipModule,
  BllIconModule,
  BllTableModule,
  // add new modules here -- keep this line for generators
];

@NgModule({
  imports: [
    CommonModule,
    BllHintModule.forRoot({
      defaultVariation: 'tooltip',
      variations: {
        tooltip: tooltipVariation,
        popper: popperVariation,
      },
    }),
    BllDialogModule.forRoot(),
    ...bllModules,
  ],
  exports: [CommonModule, BllHintModule, BllDialogModule, ...bllModules],
})
export class UiModule {}
